import React from 'react';
export const FieldError = ({ name, errors }) => errors[name] ? <p className="sim-error" id={`error-${name}`} data-testid={`error-${name.replaceAll('_', '-')}`} role="alert">{errors[name]}</p> : null;

export const TextField = ({ name, label, optional, data, update, errors, onBlur, type = 'text', ...props }) => (
  <div className="sim-field">
    <label htmlFor={`field-${name}`}>{label}{optional && <span className="sim-optional"> (facultatif)</span>}</label>
    <input id={`field-${name}`} data-testid={`${name.replaceAll('_', '-')}-input`} type={type}
      value={data[name] ?? ''} onChange={(event) => update({ [name]: event.target.value })}
      onBlur={() => onBlur?.(name)} aria-invalid={Boolean(errors[name])}
      aria-describedby={errors[name] ? `error-${name}` : undefined} {...props} />
    <FieldError name={name} errors={errors} />
  </div>
);